import moment from "moment";

export function getDefaultDealListDates(): [string, string] {
  return [
    moment().startOf("month").format("YYYY-MM-DD"),
    moment().endOf("month").format("YYYY-MM-DD"),
  ];
}

export function hasDealListDates(query: Record<string, unknown>): boolean {
  const dates = query.dates;

  return (
    Array.isArray(dates) &&
    dates.length === 2 &&
    typeof dates[0] === "string" &&
    typeof dates[1] === "string"
  );
}
